/* tslint:disable */
import { Question } from "./Question"
import { ConditionalBehaviourRule } from "./ConditionalBehaviourRule"
import { ExecutionResult } from "./ExecutionResult"

export class Section {
		StepId: number;
		Order: number;
		InstructionalText: string;
		ExecutionResult: string;
		Id: number;
		Name: string;
		Description: string;

		Questions: Question[];
		Rules: ConditionalBehaviourRule[];
		ExecutionResults: ExecutionResult[];
}



// WEBPACK FOOTER //
// D:/a/1/s/src/services/generated/models/Section.ts